import React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CustomFeild } from 'modules/custom_resources/domains/custom_field'
import { usePreviewProvider } from 'modules/processes/components/ItemWizard/Providers/preview'

const EmployeeCF = () => {
  const { previewValues } = usePreviewProvider()

  if (!previewValues.selectedFields.length) return null

  return (
    <>
      <Box paddingTop="s24" paddingBottom="s8">
        <Text.Normal size="300" color="grey800" weight="medium">
          {i18n.t(
            'processes.process_settings.wizard.tasks.types.request_general_information.preview.employee_custom_fields.label'
          )}
        </Text.Normal>
      </Box>

      <Box padding="s24" gap="s24" background="grey200" borderRadius={{ all: 'abs008' }}>
        {previewValues.selectedFields.map((customField: CustomFeild) => {
          const isSingleChoice = customField.fieldType === 'single_choice'

          return (
            <Box width="full" gap="s4" key={customField.id}>
              <Text.Normal size="200" weight="medium" color="grey1000">
                {customField.labelText}
              </Text.Normal>

              <Box
                background="grey000White"
                padding={isSingleChoice ? 's8' : 's16'}
                borderRadius={{ all: 'abs008' }}
                flexDirection="row"
                justifyContent="spaceBetween"
                alignItems="center"
                border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
              >
                {isSingleChoice ? (
                  <Box
                    paddingX="s8"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="spaceBetween"
                    width="full"
                  >
                    <Text.Normal color="grey600">
                      {customField.options[0]?.label || i18n.t('common.select_default')}
                    </Text.Normal>
                    <Icon.Small icon="caret-down" color="grey800" />
                  </Box>
                ) : (
                  <Box padding="s4"></Box>
                )}
              </Box>
            </Box>
          )
        })}
      </Box>
    </>
  )
}

export default EmployeeCF
